const en = {
  app: `app`,
  user: `user`,
  list: `list`,
  edit: `edit`,
  shop: `shop`,
  blog: `blog`,
  post: `post`,
  mail: `mail`,
  chat: `chat`,
  find: 'Find',
  cards: `cards`,
  posts: `posts`,
  create: `create`,
  submit: 'Submit',
  close: 'Close',
  Close: 'Close',
  kanban: `kanban`,
  general: `general`,
  banking: `banking`,
  booking: `booking`,
  profile: `profile`,
  account: `account`,
  product: `product`,
  invoice: `invoice`,
  details: `details1`,
  optional: 'Optional',
  checkout: `checkout`,
  calendar: `calendar`,
  analytics: `analytics`,
  ecommerce: `e-commerce`,
  management: `management`,
  menu_level_1: `menu level 1`,
  menu_level_2: `menu level 2`,
  menu_level_3: `menu level 3`,
  item_disabled: `item disabled`,
  item_label: `item label`,
  item_caption: `item caption`,
  description: `description`,
  other_cases: `other cases`,
  item_by_roles: `item by roles`,
  only_admin_can_see_this_item: `Only admin can see this item`,
  create_pricelist: `create pricelist`,
  till_managment: `Till managment`,
  till_states: `Till states`,
  limit_passed: `Limit passed`,
  subTill_limit_statistics: `SubTill limit statistics`,
  sub_tills_not_found: `SubTills not found`,
  payment_order: `Payment order`,
  home: `Home`,
  Cart: `Cart`,
  subtill_transactions: `SubTill transactions`,
  History: 'History',
  Commission: 'Commission',
  Cashdrawer: 'Cashdrawer',
  NBS_Daily_Report: 'NBS Daily Report',
  Compensation: 'Compensation',
  history_of_changes: `History of changes`,
  subtill_limits: `SubTill limits`,
  till_register_diary: `Till register diary`,
  sum_of_till_register_diary_for_location: `Sum of till register diary for location`,
  till_not_found: `Till not found`,
  close_till: `Close till`,
  open_till: `Open till`,
  reference: `Reference`,
  date_time: `Date time`,
  input: `Input`,
  output: `Output`,
  amount: `Amount`,
  Amount: `Amount`,
  currency: `Currency`,
  Currency: `Currency`,
  code: `Code`,
  Code: 'Code',
  balance: `Balance`,
  Balance: `Balance`,
  name: `Name`,
  Name: `Name`,
  type: `Type`,
  document_number: `Document number`,
  operater: `Operater`,
  date_to: `Date to`,
  date_from: `Date from`,
  Location: `Location`,
  location: 'Location',
  comment: 'Comment',
  Per_page: `Per page`,
  Enter: `Enter`,
  Input_from_bank: `Input from bank`,
  Output_from_bank: `Output to bank`,
  valid_from_date: `Valid from date`,
  location_name: `location name`,
  amount_from: `amount from`,
  amount_to: `amount to`,
  Resolved_Amount: 'Resolved Amount',
  Balance_Amount: 'Balance Amount',
  Create_new_template: `Create new template`,
  Money_order: `Money order`,
  Money_Order: 'Money Order',
  Wu_intra: `Wu intra`,
  Wu_Intra: 'Wu Intra',
  Western_union: `Western union`,
  Western_Union: 'Western Union',
  Meet_the_client: `Meet the client`,
  Meet_The_Client: 'Meet The Client',
  Money_order_domestic: `Money order domestic`,
  Money_Order_Domestic: 'Money Order Domestic',
  Money_order_international: `Money order international`,
  Money_Order_International: 'Money Order International',
  Insurance: `Insurance`,
  Vouchers: `Vouchers`,
  Daily_sales: `Daily sales`,
  Daily_Sales: 'Daily Sales',
  Presentation_review: 'Presentation review',
  Presentation_Review: 'Presentation Review',
  Manage_templates: `Manage templates`,
  Payment_cards: `Payment cards`,
  successful_copy: 'You have successfully copied to clipboard',
  Printer: 'Printer',
  Tehnical_Support: 'Tehnical Support',
  Visual_Style: 'Visual_Style',
  Language: 'Language',
  Payment_Cards: 'Payment Cards',
  Barcode: 'Barcode',
  New_In_Application: 'New In Application',
  Signature: 'Signature',
  Proxy_Server: 'Proxy Server',
  Troubleshooting: 'Troubleshooting',
  User_Details: 'User Details',
  Mobile_Application: 'Mobile Application',
  Delete_template_groups: 'Delete template groups',
  Manage_template_groups: 'Manage template groups',
  Template_groups: 'Template groups',
  Receive_Money: 'Receive Money',
  Send_Money: 'Send Money',
  Change_TX: 'Change TX',
  Request_Status: 'Request Status',
  Pay_Status: 'Pay Status',
  Reports: 'Reports',
  Documents: 'Documents',
  Price_Calc: 'Price Calc',
  Options_are_loading: 'Options are loading',
  Cart_checkout: 'Cart checkout',
  Domestic_money_order: 'Domestic money order',
  Cart_is_empty: 'Cart is empty',
  Look_like_you_have_no_items_in_your_cart: 'Look like you have no items in your cart',
  Continue_entry: 'Continue entry',
  Continue: 'Continue',
  Final_submit: 'Final submit',
  Total_fee: 'Total fee',
  Total_amount: 'Total amount',
  Assign: 'Assign',
  Assign_to_all: 'Assign to all',
  Service_type: 'Service type',

  Login_failed: 'Login failed',
  Total: 'Total',
  Hide_templates: 'Hide templates',
  Show_templates: 'Show templates',
  Recipient_Name: 'Recipient Name',
  Recipient_Account: 'Recipient Account',
  Recipient_Type: 'Recipient Type',
  Recipient_Id: 'Recipient Id',
  Payer_Id: 'Payer Id',
  Settlement_Order_Date: 'Settlement Order Date',
  Fee: 'Fee',
  State: 'State',
  Created_At: 'Created At',
  Execution_Deadline: 'Execution Deadline',
  Process_Channel_Type: 'Process Channel Type',
  Bank_Reference_Id: 'Bank Reference Id',
  Account_Number: 'Account Number',
  Reference_Number: 'Reference Number',
  Settlement_Date: 'Settlement Date',
  Agent: 'Agent',
  Presentation_demo_page: 'Presentation demo page',
  Delete_selected_templates: 'Delete selected templates',
  Delete_selected_templates_F3: 'Delete selected templates F3',
  Create_template: 'Create template',
  Finish_managing_templates: 'Finish managing templates',
  Enter_values: 'Enter values',
  Template_data: 'Template data',
  Template_name: 'Template name',
  Save_template: 'Save template',
  Group_name: 'Group name',
  Template_priority: 'Template_priority',
  Image_url: 'Image url',
  Group_view: 'Group view',
  Create_template_group: 'Create template group',
  Finish_Managing_template_groups: 'Finish Managing template groups',
  Priority: 'Priority',
  Save_template_group: 'Save template group',
  Diaries: 'Diaries',
  Info: 'Info',
  Templates: 'Templates',
  Template_group_details: 'Template group details',
  Edit_template_group: 'Edit template group',
  Template_group_update: 'Template group update',
  Template_details: 'Template details',
  Template_update: 'Template update',
  Edit_template: 'Edit template',
  Apply_template: 'Apply template',
  Save: 'Save',
  Template_group_updated: 'Template group updated',
  Payment_method_name: 'Payment method name',
  Agent_active: 'Agent active',
  Agent_name: 'Agent name',
  Digital_archive_enabled: 'Digital archive enabled',
  Location_active: 'Location active',
  Terminal_active: 'Terminal active',
  Update_terminal: 'Update terminal',
  Payments_method_added_successfully: 'Payments method added successfully',
  Payment_method_deleted_successfully: 'Payment method deleted successfully',
  bank_input1: 'bank input1',
  bank_input2: 'bank input2',
  id: 'id',
  Ready_for_submit: 'Ready for submit',
  Transaction_paid_out_successfully: 'Transaction paid out successfully',
  WU_Transaction_Details: 'WU Transaction Details',
  WU_TransactionSearch: 'WU Transaction Search',
  WU_User_Search: 'WU User Search',
  WU_Receive_money: 'WU Receive money',
  WU_com: 'WU.com',
  Western_union_money_sending: 'Western union money sending',
  Western_union_sending_money: 'Western union sending money',
  WU_money_sending_receiver_form_not_configured: 'WU money sending receiver form not configured',
  Names_do_not_match: 'Names do not match',
  Match_Receiver_Name: 'Match Receiver Name',
  First_name: 'First name',
  Last_name: 'Last name',
  Transaction_sent_out_successfully: 'Transaction sent out successfully',
  There_is_no_configuration_found: 'There is no configuration found',

  /* ------------------ */
  /*  Exhcange Office Uros part  */
  /* ------------------ */

  Exchange_Office: 'Exchange Office',
  Main_Exchange_Rate_List: 'Main Exchange Rate List',
  Create_Main_Exchange_Rate_List: 'Create Main Exchange Rate List',
  Internal_Exhcange_Rate_List: 'Internal Exhcange Rate List',
  Location_Exchange_Rate_List: 'Location Exchange Rate List',
  Number: 'Number',
  Currency_Code: 'Currency Code',
  Currency_Name: 'Currency Name',
  Denomination: 'Denomination',
  Denominations: 'Denominations',
  Lowest_Buying_Rate: 'Lowest Buying Rate',
  Buying_Rate: 'Buying Rate',
  Buying_rate: 'Buying rate',
  buying_rate: 'buying rate',
  Selling_Rate: 'Selling Rate',
  selling_rate: 'selling rate',
  Selling_rate: 'Selling rate',
  Highest_Selling_Rate: 'Highest Selling Rate',
  Range_should_be_between: 'Range should be between',
  Status: 'Status',
  Form_Exchange_Rate_List: 'Form Exchange Rate List',
  Current_Exchange_Rate_List: 'Current Exchange Rate List',
  Download_data: 'Download data',
  Print: 'Print',
  Locations: 'Locations',
  Selected_Locations: 'Selected Locations',
  Updated_Locations: 'Updated Locations',
  Please_select_locations_to_update: 'Please select locations to update',
  Locations_not_updated_yet: 'Locations not updated yet',
  Save_Internal_List_By_Locations: 'Save Internal List By Locations',
  Main_list: 'Main list',
  List_of_favorable_exchange_rates: 'List of favorable exchange rates',
  List_with_minimum_and_maximum_values: 'List with minimum and maximum values',
  Expanded_list_with_minimum_and_maximum_values: 'Expanded list with minimum and maximum values',
  Official_NBS_rates: 'Official NBS rates',
  NBS_rates_overview: 'NBS rates overview',
  Current_internal_list: 'Current internal list',
  Current_list_by_locations: 'Current list by locations',
  Choosen_Currency: 'Choosen Currency',
  Settings: 'Settings',
  Location_list_fetched_successfully: 'Location list fetched successfully',
  Ooops_something_went_wrong: 'Ooops something went wrong!',
  Buying_Global_Rate: 'Buying Global Rate',
  Selling_Global_Rate: 'Selling Global Rate',
  Middle_Exchange_Rate_NBS: 'Middle Exchange Rate NBS',
  Change_on_all_locations: 'Change on all locations',
  Form_Main_Exchange_Rate_List: 'Form Main Exchange Rate List',
  Save_main_exchange_rate_list: 'Save main exchange rate list',
  Exchange_rates_fetched_successfully: 'Exchange rates fetched successfully',
  Main_exchange_rate_list_fetched_successfully: 'Main exchange rate list fetched successfully',
  "Ooops_something_went_wrong,_couldn't_fetch_available_rates":
    "Ooops something went wrong, couldn't fetch available rates",
  Buying_Offset: 'Buying Offset',
  Selling_Offset: 'Selling Offset',
  Offset_type: 'Offset type',
  Offset_Type: 'Offset Type',
  Change_all_rates: 'Change all rates',
  Main_Exchange_Rate_List_Offsets: 'Main Exchange Rate List Offsets',
  Save_offsets: 'Save offsets',
  Succeessfully_fetched_exchange_rate_offsets: 'Succeessfully fetched exchange rate offsets',
  "Something_went_wrong,_couldn't_fetch_Exchange_Rate_Offsets":
    "Something went wrong, couldn't fetch exchange rate offsets",
  Successfully_fetched_internal_rates: 'Successfully fetched internal rates',
  Set_to_zero: 'Set to zero',
  Set_to_main_rate: 'Set to main rate',
  Set_as_main_list: 'Set as main list',
  Internal_Exchange_Rate_List: 'Internal Exchange Rate List',
  Internal_exchange_rate_list: 'Internal exchange rate list',
  Save_internal_rates: 'Save internal rates',
  Internal_exchange_rate_list_created: 'Internal exchange rate list created',
  Main_exchange_rate_list_created: 'Main exchange rate list created!',
  Location_exchange_rate_list_updated: 'Location exchange rate list updated',
  Exchange_rate_list_updated: 'Exchange rate list updated',
  Difference_should_be_in_range_between: 'Difference should be in range between',
  Value_should_be_in_range_between: 'Value should be in range between',
  and: 'and',
  Publish_exchange_rate_list: 'Publish exchange rate list',
  Purchase_Of_Damaged_Banknotes: 'Purchase Of Damaged Banknotes',
  Purchase_Of_Uncirculated_Banknotes: 'Purchase Of Uncirculated Banknotes',
  Purchase_Of_Coins: 'Purchase Of Coins',
  Print_exchange_rate_list: 'Print exchange rate list',
  Confirmations: 'Confirmations',
  Ulazi_i_izlazi: 'Ulazi i izlazi',
  Commercial_bank_exchange_rate: 'Commercial bank exchange rate',
  Change_offsets_based_on_middle_exchange_rate_NBS:
    'Change offsets based on middle exchange rate NBS',
  Buying_rate_offset: 'Buying rate offset',
  Selling_rate_offset: 'Selling rate offset',
  Create_exchange_rate_list: 'Create exchange rate list',
  Review_and_update_exchange_rate_list: 'Review and update exchange rate list',
  Middle_exchange_rate_NBS: 'Middle exchange rate NBS',
  'The_NBS_exchange_for_cash_tranastions_(Effective)_and_the_middle_rate_for_other_currencies':
    'The NBS exchange for cash tranastions (Effective) and the middle rate for other currencies',
  'Previous_values_(Previous_list_settings)': 'Previous values (Previous list settings)',
  Basis_when_creating_exchange_rate_list: 'Basis when creating exchange rate list',
  Internal_List_Settings_Based_on_Main_Rate: 'Internal List Settings Based on Main Rate',
  Show_only_active_rates: 'Show only active rates',
  Value_is_not_in_the_provided_range: 'Value is not in the provided range',
  Currency_subtypes_updated_successfully: 'Currency subtypes updated successfully',
  Internal_rate_updated_successfully: 'Internal rate updated successfully',
  Official_NBS_list: 'Official NBS list',
  LISTS_HISTORY: 'LISTS HISTORY',
  Inputs_and_outputs: 'Inputs and outputs',
  Security: 'Security',
  Integrations: 'Integrations',
  Print_date_and_time_on_list: 'Print date and time on list',
  Print_current_date_on_main_list: 'Print current date on main list',
  'Main_exchange_rate_list_(text_line_below_list)':
    'Main exchange rate list (text line below list)',
  'Commision_list_(text_line_below_list)': 'Commision list (text line below list)',
  'Minimum_and_maximum_amounts_(text_line_below_list)':
    'Minimum and maximum amounts (text line below list)',
  Print_accounting_exchange_rate_report_separately_by_conditions:
    'Print accounting exchange rate report separately by conditions',
  'Reports_by_location_(exchange_place)': 'Reports by location (exchange place)',
  'Sort_JOURNAL_in_descending_order_(last on top)':
    'Sort JOURNAL in descending order (last on top)',
  'Journal_transactions_by_location_(exchange_place)_/_for_worker':
    'Journal transactions by location (exchange place) / for worker',
  'Slip_start_ext_(e.g._company_name)': 'Slip start text (e.g. company name)',
  'Slip_end_text_(e.g._Thanks...)': 'Slip end text (e.g. Thanks...)',
  Print_application_name: 'Print application name',
  Additional_slip_with_confirmation: "Additional 'slip' with confirmation",
  Print_if_conditions_are_met: 'Print if conditions are met',
  'Connected_internal_inputs_and_outputs_(internal_output_must_match_internal)':
    'Connected internal inputs and outputs (internal output must match internal)',
  In_local_mode_do_not_connect_internal_inputs_to_enable_synchronization:
    'In local mode do not connect  internal inputs to enable synchronization',
  Allow_exchange_rate_input_when_creating_internal_inputs_and_outputs:
    'Allow exchange rate input when creating internal inputs and outputs',
  Do_nothing: 'Do nothing',
  Ask_for_input_to_another_till: 'Ask for input to another till',
  Automatically_add_another_input_to_till: 'Automatically add another input to till',
  Print_denomination_structure_during_internal_outputs:
    'Print denomination structure during internal outputs',
  Print_denomination_structure_while_handing_it_over_to_the_bank:
    'Print denomination structure while handing it over to the bank',
  Print_denomination_structure_during_outputs_to_till:
    'Print denomination structure during outputs to till',
  Mandatory_denomination_structure_for_transactions_in_EUR:
    'Mandatory denomination structure for transactions in EUR',
  Mandatory_denomination_structure_for_outputs_and_inputs_in_EUR:
    'Mandatory denomination structure for outputs and inputs in EUR',
  Specification_print_settings: 'Specification print settings',
  'On_the_printer_for_confirmations_(narrower_format_in_the_width_of_the_confirmation)':
    'On the printer for confirmations (narrower format in the width of the confirmation)',
  'On_the_report_printer_(A4_format)': 'On the report printer (A4 format)',
  'Employee_(managers)_restrictions_by_regions_(locations)_and_operations':
    'Employee (managers) restrictions by regions (locations) and operations',
  Add: 'Add',
  Edit: 'Edit',
  Delete: 'Delete',
  Integration_with_the_accounting_system: 'Integration with the accounting system',
  Integration_type: 'Integration type',
  'From_(RSD)': 'From (RSD)',
  'To_(RSD)': 'To (RSD)',
  Text: 'Text',
  Server_address: 'Server address',
  Review_data_before_sending: 'Review data before sending',
  'Transaction_amount_(RSD)': 'Transaction amount (RSD)',
  Text_to_print_with_slip: 'Text to print with slip',
  Select_slip_to_edit_or_delete: 'Select slip to edit or delete',
  Test_review: 'Test review',
  Test_print: 'Test print',
  Region: 'Region',
  Consolidated_cash_journal_in_vertical_format_for_smaller_currencies:
    'Consolidated cash journal in vertical format for smaller currencies',
  Reports_in_new_format: 'Reports in new format',
  Internal_transfers_between_payment_and_exchange_office_till_After_creating_output:
    'Internal transfers between payment and exchange office till After creating output',
  User_name: 'User name',
  Name_and_last_name: 'Name and last name',
  Responsibilities: 'Responsibilities',

  /* ------------------ */
  /*  Till mannagement  */
  /* ------------------ */
  Till: 'Till',
  time: 'Time',
  refund: 'Refund',
  to_refund: 'Refund',
  status: 'Status',
  subtills: 'Subtills',
  set_limit: 'Set limit',
  opened_till: 'Opened till',
  closed_till: 'Closed till',
  service_type: 'Service type',
  general_input: 'General input',
  refund_reason: 'Refund reason',
  general_output: 'General output',
  output_number: 'Output number',
  internal_input: 'Internal input',
  internal_output: 'Internal output',
  input_from_bank_account: 'Input from bank account',
  output_to_bank_account: 'Output to bank account',
  till_management: 'Till management',
  is_refunded: 'Refunded',
  regular_currency: 'Regular currency',
  from_last_opening: 'From last opening',
  till_transactions: 'Till transactions',
  transaction_type: 'Transaction type',
  sub_till_limits_state: 'SubTill limits state',
  make_till_transaction: 'Make till transaction',
  make_till_input_transaction: 'Make till input transaction',
  make_till_output_transaction: 'Make till output transaction',
  obsolete_damaged_currency: 'Obsolete/damaged currency',
  internal_output_for_input: 'Internal output for input',
  transaction_created_successfully: 'Transasction created successfully',
  internal_input_from_exchange_till: 'Internal input from exchange till',
  set_till_limit: 'set till limit',
  Error_while_opening_till: 'Error while opening till',
  till_closed_successfully: 'Till closed successfully',
  till_opened_successfully: 'Till opened successfully',
  till_transaction_refunded_successfully: 'Till transaction refunded successfully',
  Success_set_base_debt_limit_agent: 'Successfully updated base debt limit for agent',
  Success_updated_location_debt_limit_for_currency:
    'Successfully updated location debt limit for currency',
  banknote_balance: 'Banknote balance',
  coin_balance: 'Coin balance',

  // SETTINGS
  General_settings: 'General settings',
  Till_settings: 'Till settings',
  Should_pair_for_internal_transactions: 'Should pair input/output for internal transactions',
  Updated_requirements_successfully: 'Updated requirements successfully',
  Set_till_configuration_successfully: 'Till configuration updated successfully',
  Till_currency_denomination: 'Till currency denomination',

  // WU
  mtcn: 'MTCN',
  sender: 'Sender',
  receiver: 'Receiver',
  transactions: 'Transactions',
  reference_number: 'Reference number',
  transactions_table: 'Transactions table',
  search_and_overview: 'Search and overview',
  transaction_overview: 'Transaction overview',
  WU_root: 'Western Union',
  WU_search_and_overview: 'Search and overview',
  WU_transaction_overview: 'Transaction overview',
};

export default en;
